var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.typeComponent,_vm._g({tag:"component",attrs:{"entity":_vm.entity,"entity-id":_vm.entityId,"is-nested-entity":_vm.isNestedEntity,"tab-data":_vm.tabData}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }